import React, { useEffect, useState } from "react";

import { useFormik } from "formik";
import * as yup from "yup";
import { Validation } from "../../utils/validations";
import toast from "react-hot-toast";
import Loading from "shared/Loading/Loading";

import RenderMain from "./RenderMain";
import RenderSidebar from "./RenderSidebar";
import { useMetadataUser } from "contexts/metadata-user-context";
import { useNavigate, useSearchParams } from "react-router-dom";
import { updatePaymentData } from "services/update-paymenty-data";
import { getBrand } from "services/get-brand";

export const UpdatePaymentData = () => {
  const [infoCardFocus, setInfoCardFocus] = useState("");
  const [loading, setLoading] = useState<boolean>(false);
  const [blockInputs, setBlockInputs] = useState<boolean>(false);
  const { profile } = useMetadataUser();

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const recurrentId = searchParams?.get("id");

  const validationSchema = yup.object({
    number: yup.string().required("Número do cartão é obrigatório"),
    name: yup.string().required("Nome do titular é obrigatório"),
    expiry: yup
      .string()
      .test("is-valid-date", "Data inválida", (value) => {
        return value ? Validation.isValidDateCredit(value) : false;
      })
      .required("Validade é obrigatório"),
    cvc: yup.string().required("CVC/CVV é obrigatório"),
  });

  const formik = useFormik({
    initialValues: {
      number: "",
      name: "",
      expiry: "",
      cvc: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      const brand: any = await getBrand(
        values.number.split(" ").join("").substring(0, 6)
      );

      if (brand.response.status !== 200) {
        setLoading(false);
        toast.error(brand.detail, { duration: 10000 });
        return;
      }

      if (!profile?.subscription?.monthly_value) {
        setLoading(false);
        toast.error("Erro ao buscar valor da assinatura");
        return;
      }

      if (!recurrentId) {
        setLoading(false);
        toast.error("Erro ao buscar id da assinatura");
        return;
      }

      const params = {
        card_number: values.number.split(" ").join(""),
        holder: values.name,
        expiration_date: values.expiry,
        brand: brand?.rest?.provider,
      };

      try {
        await updatePaymentData(recurrentId, params);

        setBlockInputs(true)
        toast.success(
          "Cartão alterado com sucesso",
          { duration: 6000 }
        );

        setTimeout(() => {
          navigate("/home");
        }, 4000);
      } catch (error) {
        if (error instanceof Error) {
          toast.error("Falha ao tentar alterar o cartão de crédito, tente novamente!");
          return 0;
        }

        toast.error("Erro ao atualizar dados de pagamento");
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    if (!recurrentId) {
      navigate("/home");
    }
  }, []);

  const handleError = (fieldName: keyof any, formik: any) => {
    if (formik.touched[fieldName] && Boolean(formik.errors[fieldName])) {
      return `mt-1 border border-red-500 focus:ring-2 focus:outline-none focus:ring-red-500 focus:border-red-500`;
    }
    return `mt-1 border border-neutral-300 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent`;
  };

  return (
    <div className={`nc-CheckOutPagePageMain md:h-[calc(100vh-11rem)]`}>
      <main className="container mt-0 md:mt-11 mb-24 lg:mb-32 flex flex-col-reverse lg:flex-row">
        {loading ? (
          <Loading size={70} />
        ) : (
          <>
            <div className="w-full mt-6 md:mt-0 lg:w-3/5 xl:w-2/3 lg:pr-10 ">
              <RenderMain
                infoCardFocus={infoCardFocus}
                formik={formik}
                disableAllInputs={ blockInputs }
                handleError={handleError}
                handleInputFocus={(event: React.FocusEvent<HTMLInputElement>) =>
                  setInfoCardFocus(event.target.name)
                }
              />
            </div>
            <div className="hidden lg:block flex-grow">
              <RenderSidebar infoCardFocus={infoCardFocus} formik={formik} />
            </div>
          </>
        )}
      </main>
    </div>
  );
};
